module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAJCAYAAADzRkbkAAAAF0lEQVQImWOYtHjNfyYGBgYGQgQDAwMAex0C8fVvPD8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/copyright/line.png
// module id = 73gW
// module chunks = 1